var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTesting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 16,
    viewBox: "0 0 30 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0418 12.157C14.9439 12.157 14.8459 12.141 14.7526 12.1106L4.91403 8.91975C4.65562 8.83594 4.39063 9.02858 4.39063 9.30024V12.7117C4.38969 13.1382 4.65484 13.5174 5.04856 13.6528L6.15201 14.03C11.8963 15.99 18.1035 15.99 23.8478 14.03L24.9475 13.6537C25.345 13.5193 25.6129 13.1368 25.6101 12.7068V9.31312C25.6101 9.04123 25.3447 8.84857 25.0862 8.9328L15.3333 12.1106C15.2391 12.1415 15.1407 12.157 15.0418 12.157Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.17238 5.03592C0.803877 5.15651 0.805275 5.6783 1.17442 5.79691L15.0338 10.25L28.8314 5.79675C29.1998 5.67782 29.2012 5.157 28.8334 5.03609L15.0338 0.5L1.17238 5.03592Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTesting);
export default __webpack_public_path__ + "static/media/icon-testing.cb0725b3a35e25bbecb80391b3095827.svg";
export { ForwardRef as ReactComponent };